class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    if (window.matchMedia('(max-width: 767px)').matches) {

      $('.c-side__btn').on('click', function() {
        var findElm = $(this).next(".c-side__archiveList");
        $(findElm).slideToggle();
          
        // if($(this).hasClass('close')){//a-triggerにクラス名closeがあれば
        //   $(this).removeClass('close');//クラス名を除去し
        // }else{//それ以外は
        //   $(this).addClass('close');//クラス名closeを付与
        // }
      });
  
      $(window).on('load', function(){
        $(".open").each(function(index, element){
          var Title =$(element).children('.c-side__btn');
          $(Title).addClass('close');
          var Box =$(element).children('.c-side__archiveList');
          $(Box).slideDown(500);
        });
      });

    } else if (window.matchMedia('(min-width:768px)').matches) {
      //PC動作なし
    }
  }
}
